module.exports = __webpack_public_path__ + "img/icon-track-gray.758d05f9.svg";